export default __webpack_public_path__ + "static/media/warning--accident-area--g6.271d6630.png";